import {
  BuyAndWinBenefitVariant,
  MoreForLessBenefitVariant,
  RegularBenefitVariant,
} from '../typings'
import { messages } from './messages'

/**
 * This mapping makes reference to the path fields inside the Promotion type.
 */
export enum BenefitIncompatibleField {
  MAX_PER_CART = 'restrictions.maxItemsPerCart',
  MAX_PER_ATTRIBUTE = 'restrictions.maxItemsPerAttribute',
  ACCUMULATE_WITH_MANUAL_PRICES = 'restrictions.accumulateWithManualPrices',
  ACCUMULATE = 'restrictions.accumulate',
  BUDGET = 'restrictions.budget',
}

export const incompatibilityRules = [
  {
    field: BenefitIncompatibleField.ACCUMULATE_WITH_MANUAL_PRICES,
    when: [
      RegularBenefitVariant.FreeShipping,
      RegularBenefitVariant.MaxShipping,
      RegularBenefitVariant.NominalShipping,
      RegularBenefitVariant.PercentualShipping,
      RegularBenefitVariant.Gift,
      RegularBenefitVariant.NominalLoyalty,
      RegularBenefitVariant.PercentualLoyalty,
      RegularBenefitVariant.PriceTable,
      RegularBenefitVariant.Formula,
      RegularBenefitVariant.MaxPrice,
      MoreForLessBenefitVariant.MAX_PRICE_PER_ITEM,
    ],
  },
  {
    field: BenefitIncompatibleField.ACCUMULATE,
    when: [RegularBenefitVariant.PriceTable],
  },
  {
    field: BenefitIncompatibleField.MAX_PER_CART,
    when: [
      RegularBenefitVariant.FreeShipping,
      RegularBenefitVariant.MaxShipping,
      RegularBenefitVariant.NominalShipping,
      RegularBenefitVariant.PercentualShipping,
      RegularBenefitVariant.Gift,
      RegularBenefitVariant.NominalLoyalty,
      RegularBenefitVariant.PercentualLoyalty,
      RegularBenefitVariant.PriceTable,
    ],
  },
  {
    field: BenefitIncompatibleField.MAX_PER_ATTRIBUTE,
    when: [
      RegularBenefitVariant.FreeShipping,
      RegularBenefitVariant.MaxShipping,
      RegularBenefitVariant.NominalShipping,
      RegularBenefitVariant.PercentualShipping,
      RegularBenefitVariant.Gift,
      RegularBenefitVariant.NominalLoyalty,
      RegularBenefitVariant.PercentualLoyalty,
      RegularBenefitVariant.PriceTable,
      RegularBenefitVariant.Formula,
      RegularBenefitVariant.MaxPrice,
      RegularBenefitVariant.Nominal,
    ],
  },
  {
    field: BenefitIncompatibleField.BUDGET,
    when: [
      RegularBenefitVariant.Formula,
      RegularBenefitVariant.FreeShipping,
      RegularBenefitVariant.MaxShipping,
      RegularBenefitVariant.NominalShipping,
      RegularBenefitVariant.PercentualShipping,
      RegularBenefitVariant.Gift,
      RegularBenefitVariant.NominalLoyalty,
      RegularBenefitVariant.PercentualLoyalty,
      BuyAndWinBenefitVariant.FREE_SHIPPING,
      BuyAndWinBenefitVariant.GIFT,
    ],
  },
]

export const fieldMessages = {
  [BenefitIncompatibleField.ACCUMULATE_WITH_MANUAL_PRICES]: {
    section: messages.accumulateWithManual.section,
    config: messages.accumulateWithManual.config,
  },
  [BenefitIncompatibleField.ACCUMULATE]: {
    section: messages.accumulate.section,
    config: messages.accumulate.config,
  },
  [BenefitIncompatibleField.MAX_PER_CART]: {
    section: messages.restrictionsCart.section,
    config: messages.restrictionsCart.config,
  },
  [BenefitIncompatibleField.MAX_PER_ATTRIBUTE]: {
    section: messages.restrictionsAttribute.section,
    config: messages.restrictionsAttribute.config,
  },
  [BenefitIncompatibleField.BUDGET]: {
    section: messages.budget.section,
    config: messages.budget.config,
  },
}
